<template>
  <SearchBar>
    <el-date-picker
      size="small"
      v-model="newMonth"
      type="month"
      :placeholder="this.$t('search.selMonth')"
      :change="handleChangeSearchType"
      value-format="yyyyMM"
    >
    </el-date-picker>
    <el-button-group>
      <el-button size="small" type="primary" @click="handleSearch" style="margin-left: 15px;">{{$t('search.search')}}</el-button>
      <el-button size="small" @click="handleReset">{{$t('search.reset')}}</el-button>
    </el-button-group>
  </SearchBar>
</template>

<script>
import SearchBar from "@/components/common/SearchBar.vue";
export default {
  name: "SearchCriterial",
  components: { SearchBar },
  props: {
    handleReset: Function,
    searchParams: Object,
    handleChangeSearchParams: Function,
    handleSearch: Function
  },
  methods: {
    handleChangeSearchType(val) {
      this.handleChangeSearchParams({ ...this.searchParams, searchType: val });
      this.handleSearch();
    }
  },
  computed: {
    newMonth: {
      get() {
        return this.searchParams.searchType;
      },
      set(val) {        
        this.handleChangeSearchParams({
          ...this.searchParams,
          searchType: val
        });
      }
    }
  }
};
</script>
